import { render } from "./sales-left-search.vue?vue&type=template&id=1dfa4a28"
import script from "./sales-left-search.vue?vue&type=script&lang=js"
export * from "./sales-left-search.vue?vue&type=script&lang=js"

import "./sales-left-search.vue?vue&type=style&index=0&id=1dfa4a28&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__